import Vue from 'vue'
import Router, { RouteConfig } from 'vue-router'

import store from '@/store'
import { bus } from './main';
import { Languages, DocumentLanguage } from '@/enums'

import SelectAge from './views/SelectAge.vue'
const SelectBranch = () => import('./views/SelectBranch.vue')
const CriminalRecord = () => import('./views/CriminalRecord.vue')
const SelectCrime = () => import('./views/SelectCrime.vue')
const SelectPunishment = () => import('./views/SelectPunishment.vue')
const CrimeWhen = () => import('./views/CrimeWhen.vue')
const PunishmentWhen = () => import('./views/PunishmentWhen.vue')
const PunishmentLength = () => import('./views/PunishmentLength.vue')
const Results = () => import('./views/Results.vue')

Vue.use(Router)

const routes: RouteConfig[] = [
	{
		path: '/',
		name: 'home',
		component: SelectAge
	},
	{
		path: '/en',
		name: 'home-en',
		component: SelectAge,
		meta: {
			language: Languages.EN,
		}
	},
	{
		path: '/nl/leeftijd',
		name: 'select-age',
		component: SelectAge,
		meta: {
			pageTitle: 'Leeftijd'
		},
	},
	{
		path: '/en/age',
		name: 'select-age-en',
		component: SelectAge,
		meta: {
			language: Languages.EN,
			pageTitle: 'Age'
		}
	},
	{
		path: '/nl/branches',
		name: 'select-branch',
		component: SelectBranch,
		meta: {
			pageTitle: 'Branches',
			requiredUserField: 'age'
		}
	},
	{
		path: '/en/branches',
		name: 'select-branch-en',
		component: SelectBranch,
		meta: {
			language: Languages.EN,
			pageTitle: 'Branches',
			requiredUserField: 'age'
		}
	},
	{
		path: '/nl/strafblad',
		name: 'criminal-record',
		component: CriminalRecord,
		meta: {
			pageTitle: 'Strafblad',
			requiredUserField: 'preferredBranches'
		}
	},
	{
		path: '/en/criminal-record',
		name: 'criminal-record-en',
		component: CriminalRecord,
		meta: {
			language: Languages.EN,
			pageTitle: 'Record',
			requiredUserField: 'preferredBranches'
		}
	},
	{
		path: '/nl/delicten',
		name: 'select-crime',
		component: SelectCrime,
		meta: {
			pageTitle: 'Delicten',
			requiredUserField: 'criminalRecord'
		}
	},
	{
		path: '/en/crimes',
		name: 'select-crime-en',
		component: SelectCrime,
		meta: {
			language: Languages.EN,
			pageTitle: 'Crimes',
			requiredUserField: 'criminalRecord'
		}
	},
	{
		path: '/nl/straffen',
		name: 'select-punishment',
		component: SelectPunishment,
		meta: {
			pageTitle: 'Straffen',
			requiredUserField: 'selectedCrime'
		}
	},
	{
		path: '/en/punishments',
		name: 'select-punishment-en',
		component: SelectPunishment,
		meta: {
			language: Languages.EN,
			pageTitle: 'Punishments',
			requiredUserField: 'selectedCrime'
		}
	},
	{
		path: '/nl/wanneer-veroordeeld',
		name: 'crime-when',
		component: CrimeWhen,
		meta: {
			pageTitle: 'Wanneer veroordeeld',
			requiredUserField: 'selectedPunishment'
		}
	},
	{
		path: '/en/when-convicted',
		name: 'crime-when-en',
		component: CrimeWhen,
		meta: {
			language: Languages.EN,
			pageTitle: 'When convicted',
			requiredUserField: 'selectedPunishment'
		}
	},
	{
		path: '/nl/wanneer-bestraft',
		name: 'punishment-when',
		component: PunishmentWhen,
		meta: {
			pageTitle: 'Wanneer bestraft',
			requiredUserField: 'selectedPunishment'
		}
	},
	{
		path: '/en/when-punished',
		name: 'punishment-when-en',
		component: PunishmentWhen,
		meta: {
			language: Languages.EN,
			pageTitle: 'When punished',
			requiredUserField: 'selectedPunishment'
		}
	},
	{
		path: '/nl/hoe-lang',
		name: 'punishment-length',
		component: PunishmentLength,
		meta: {
			pageTitle: 'Strafduur',
			requiredUserField: 'punishmentWhen'
		}
	},
	{
		path: '/en/how-long',
		name: 'punishment-length-en',
		component: PunishmentLength,
		meta: {
			language: Languages.EN,
			pageTitle: 'Punishment duration',
			requiredUserField: 'punishmentWhen'
		}
	},
	{
		path: '/nl/resultaat',
		name: 'results',
		component: Results,
		meta: {
			pageTitle: 'Resultaat'
		}
	},
	{
		path: '/en/results',
		name: 'results-en',
		component: Results,
		meta: {
			language: Languages.EN,
			pageTitle: 'Results',
		}
	},
	{
		path: '*',
		redirect: { name: 'home' }
	}
]

const router = new Router({
	mode: 'history',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach((to, from, next) => {
	const user = store.getters.user

	setTimeout(() => {
		bus.$emit('setPreviousButton', 'previous')
		
		window.scrollTo(0, 0)
	}, 200)

	if (to.meta.pageTitle) {
		document.title = ('VOG-check | ' + to.meta.pageTitle)
	} else {
		document.title = 'VOG-check'
	}

	if(to.meta.language) {
		store.dispatch('setLanguage', to.meta.language)
		// Set html lang attribute
		document.documentElement.lang = DocumentLanguage[(to.meta.language.toUpperCase() as keyof typeof DocumentLanguage)]
	} else {
		document.documentElement.lang = DocumentLanguage.NL
	}

	if (to.meta.requiredUserField) {
		if (user[to.meta.requiredUserField]) {
			next()
		} else {
			next('/')
		}
	}

	if (to.name === 'results') {
		if (user.criminalRecord) {
			setTimeout(() => {
				bus.$emit('setPreviousButton', 'start')
			}, 200)

			if (user.criminalRecord === 'no') {
				next()
			} else {
				if (user.selectedPunishment) {
					let matchingPunishment = false

					;[...(<any>store.getters.punishments)].forEach((punishment: { name: string, value: string, requiresDate?: boolean }) => {
						if (user.selectedPunishment === punishment.value) {
							matchingPunishment = true

							if (punishment.requiresDate) {
								if (user.punishmentWhen && user.punishmentLength) {
									next()
								} else {
									next('/')
								}
							} else {
								if (user.crimeWhen) {
									next()
								} else {
									next('/')
								}
							}
						}
					})

					if (!matchingPunishment) {
						next('/')
					}
				} else {
					next('/')
				}
			}
		} else {
			next('/')
		}
	}

	bus.$emit('closeInfo')

	next()
})

router.afterEach((to, from) => {
	_paq.push(['setCustomUrl', to.path])
	_paq.push(['setDocumentTitle', document.title])
	_paq.push(['trackPageView'])

	// every time the user goes to a different page, start the focus on the logo at the top
	const logoElement = document.querySelector(".vog-check-logo__container ") as HTMLElement;
	if(logoElement) {
		logoElement.focus()
	}
})

export default router
